module.exports = __webpack_public_path__ + "static/media/rewind.033e3eab.svg";